import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-dashboard',
    template: require('./dashboard.component.html'),
    styles: []
})
export class DashboardComponent implements OnInit {
    doctorPurchaseChart: any;
    doctorPurchaseChart2: any;
    doctorPurchaseChart3: any;
    doctorPurchaseChart4: any;
    doctorPurchaseChart5: any;
    doctorPurchaseChart6: any;
    DashBoardModel: any;
    TopFiveEmployeeList: any;
    BrandWisePOB: any;
    DivisionWisePOB: any;
    WeeklyGrowthPOB: any;
    POBStatus: any;
    POBStockist: any;
    POBSecondary: any;

    public Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];
    public Year = ["2017", "2018", "2019", "2020"];
    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }

    static parameters = [Router, ActivatedRoute, HttpClient]
    constructor(private router: Router, private activatedRoute: ActivatedRoute, private http: HttpClient) {

    }

    ngOnInit() {

        this.DashBoardModel = {
            TotalPOBValue: 0,
            TotalStockistPOB: 0,
            TotalLeadCall: 0,
            TotalFieldForce: 0,
            CustomerWiseRetailerPOB: 0,
            CustomerWiseStockistPOB: 0,
        };
        this.TopFiveEmployeeList = [];
        this.BrandWisePOB = [];
        this.DivisionWisePOB = [];
        this.LoadStateWisePOBStatusMap();
        this.GetOverTotalValue();
        this.GetTopFiveEmployeePOB();
        this.getBrandWisePOB();
        this.getDivisionWisePOB();
        this.getWeeklyGrowthPOB();
        // this.getPOBStatus();
        this.getPOBStockist();
        this.getPOBSecondary();
        this.getStateWisePOBStatusMap();
    }

    ngOnDestroy() {

    }

    GetOverTotalValue() {
        var Data = {};
        this.http.post('/api/Dashboards/getDashboardOverAllTotal', Data)
            .subscribe((res: any) => {
                console.log('res :', res);
                if (res.length > 0) {
                    this.DashBoardModel.TotalPOBValue = res[0]["TotalPOBValue"];
                    this.DashBoardModel.TotalStockistPOB = res[0]["TotalStockistPOB"];
                    this.DashBoardModel.TotalLeadCall = res[0]["TotalLeadCall"];
                    this.DashBoardModel.TotalFieldForce = res[0]["TotalFieldForce"];
                    this.DashBoardModel.CustomerWiseRetailerPOB = res[0]["CustomerWiseRetailerPOB"];
                    this.DashBoardModel.CustomerWiseStockistPOB = res[0]["CustomerWiseStockistPOB"];
                }
            });
    }

    GetTopFiveEmployeePOB() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "EmpId": token.clientId };
        this.http.post('/api/Dashboards/getDashboardTopFiveEmployeePOB', Data)
            .subscribe(res => {
                console.log('res :', res);
                this.TopFiveEmployeeList = res;
            });
    }

    getBrandWisePOB() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "BrandWise", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {
                var BrandWise = [];
                this.BrandWisePOB = res;
                this.BrandWisePOB.forEach(function (e) {
                    var BrandWisedata = [];
                    BrandWisedata.push(e.brand, e.pob_value, true);
                    BrandWise.push(BrandWisedata);
                });
                this.LoadBrandWiseChart(BrandWise);
            });
    }

    LoadBrandWiseChart(data) {
        let chart = new Chart({
            chart: {
                styledMode: true
            },

            title: {
                text: null
            },

            // xAxis: {
            //     categories: ['Entair', 'Glovent', 'Entros', 'Other',
            //         'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            // },
            credits: {
                enabled: false
            },
            series: [{
                type: 'pie',
                allowPointSelect: true,
                keys: ['name', 'y', 'selected', 'sliced'],
                data: data,
                showInLegend: true
            }]
        });
        this.doctorPurchaseChart = chart;
    }

    getDivisionWisePOB() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "DivisionWise", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {
                var DivisionWise = [];
                this.DivisionWisePOB = res;
                this.DivisionWisePOB.forEach(function (e) {
                    var DivisionWisedata = [];
                    DivisionWisedata.push(e.division, e.pob_value, true);
                    DivisionWise.push(DivisionWisedata);
                });
                this.LoadDivisionWiseChart(DivisionWise);
            });
    }

    LoadDivisionWiseChart(data) {
        this.doctorPurchaseChart2 = new Chart({

            chart: {
                type: 'pie',
                options3d: {
                    enabled: true,
                    alpha: 45
                }
            },
            title: {
                text: null
            },
            subtitle: {
                text: null
            },
            plotOptions: {
                pie: {
                    innerSize: 45,
                    depth: 45
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'POB Value',
                data: data,
                showInLegend: true
            }]
        });
    }

    getWeeklyGrowthPOB() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "WeeklyGrowth", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {
                this.WeeklyGrowthPOB = res;
                var parent = this;
                let dataset = [];
                this.WeeklyGrowthPOB.forEach(function (e) {
                    var WeeklyGrowth = [];
                    parent.Days.forEach(function (day) {
                        let enteries = Object.entries(e);
                        let indx = enteries.findIndex(e => (e[0] == day));
                        if (indx != -1) {
                            WeeklyGrowth.push(enteries[indx][1]);
                        }
                    });
                    dataset.push({ name: e.location, data: WeeklyGrowth });

                });
                console.log(dataset);

                this.LoadWeeklyGrowthChart(dataset);
            });
    }

    LoadWeeklyGrowthChart(data) {
        this.doctorPurchaseChart3 = new Chart({
            chart: {
                type: 'area'
            },
            title: {
                text: null
            },
            subtitle: {
                text: null
            },
            xAxis: {
                categories: ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'],
                tickmarkPlacement: 'on',
                title: {
                    enabled: false
                }
            },
            yAxis: {
                title: {
                    text: 'Billions'
                },
                labels: {
                    formatter: function () {
                        return this.value / 1000;
                    }
                }
            },
            tooltip: {
                split: true,
                valueSuffix: ' millions'
            },
            plotOptions: {
                area: {
                    stacking: 'normal',
                    lineColor: '#666666',
                    lineWidth: 1,
                    marker: {
                        lineWidth: 1,
                        lineColor: '#666666'
                    }
                }
            },
            credits: {
                enabled: false
            },
            series: data
        });
    }

    getPOBStatus() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "POBStatus", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {

                this.POBStatus = res;
                var parent = this;
                var DataSet = [];
                this.POBStatus.forEach(function (e) {
                    var POBStatus = [];
                    parent.Year.forEach(function (year) {
                        let enteries = Object.entries(e);
                        let indx = enteries.findIndex(e => (e[0] == year));
                        if (indx != -1) {
                            POBStatus.push(enteries[indx][1]);
                        }
                    });
                    DataSet.push({ name: e.grade, data: POBStatus });

                });
                console.log(DataSet);

                this.LoadPOBStatusChart(DataSet);
            });
    }

    LoadPOBStatusChart(data) {
        this.doctorPurchaseChart4 = new Chart({

            title: {
                text: 'Solar Employment Growth by Sector, 2010-2016'
            },

            subtitle: {
                text: 'Source: thesolarfoundation.com'
            },

            yAxis: {
                title: {
                    text: 'Number of Employees'
                }
            },

            xAxis: {
                accessibility: {
                    rangeDescription: 'Range: 2017 to 2021'
                }
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },

            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    pointStart: 2017
                }
            },

            series: data,

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }

        });
    }

    getPOBSecondary() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "POBSecondary", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {
                this.POBSecondary = res;
                var parent = this;
                var POBDataSet = [];
                const categories = Array.from(new Set(this.POBSecondary.map(item => item.Brand)));
                categories.forEach(cat => {
                    var POBBrand = [];
                    parent.POBSecondary.forEach(brand => {
                        if (cat == brand.Brand) {
                            POBBrand.push(brand.value);
                        }

                    });
                    POBDataSet.push({ name: cat, data: POBBrand });
                });
                // POBDataSet.push({ name: cat, data: POBBrand });
                console.log(POBDataSet, categories)
                this.LoadPOBSecondaryChart(POBDataSet, categories);
            });
    }

    LoadPOBSecondaryChart(Series, categories) {
        this.doctorPurchaseChart5 = new Chart({
            chart: {
                type: 'column',
                options3d: {
                    enabled: true,
                    alpha: 15,
                    beta: 15,
                    viewDistance: 25,
                    depth: 40
                }
            },

            title: {
                text: null
            },


            xAxis: {
                categories: categories,
                labels: {
                    skew3d: true,
                    style: {
                        fontSize: '16px'
                    }
                }
            },

            yAxis: {
                allowDecimals: false,
                min: 0,
                title: {
                    text: 'Growth of POB',
                    skew3d: true
                }
            },

            tooltip: {
                headerFormat: '<b>{point.key}</b><br>',
                pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: {point.y} / {point.stackTotal}'
            },

            plotOptions: {
                column: {
                    stacking: 'normal',
                    depth: 40
                }
            },
            credits: {
                enabled: false
            },
            series: Series
            // series: [{
            //     name: 'Safent',
            //     data: [5, 3, 4, 7],
            //     //  stack: 'male'
            // }, {
            //     name: 'Entair',
            //     data: [3, 4, 4, 2],
            //     // stack: 'male'
            // }, {
            //     name: 'Glovent',
            //     data: [2, 5, 6, 2],
            // //  stack: 'female'
            // }, {
            //     name: 'Entros',
            //     data: [3, 0, 4, 4],
            //     //  stack: 'female'
            // }]
        });
    }

    getPOBStockist() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "POBStockist", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {
                this.POBStockist = res;
                var POBStockist = [];
                this.POBStockist.forEach(function (e, i) {
                    var data = "[" + e.value + "]";
                    data = JSON.parse(data)
                    POBStockist.push({ name: e.name, data: data, yAxis: i });
                });
                console.log(POBStockist);
                this.LoadPOBStockistChart(POBStockist);
            });


    }

    LoadPOBStockistChart(data) {
        this.doctorPurchaseChart6 = new Chart({
            chart: {
                type: 'column',
                styledMode: true
            },

            title: {
                text: null
            },

            yAxis: [{
                className: 'highcharts-color-0',
                title: {
                    text: 'Primary POB'
                }
            },
            {
                className: 'highcharts-color-1',
                opposite: true,
                title: {
                    text: 'Secondary POB '
                }
            }
            ],

            plotOptions: {
                column: {
                    borderRadius: 5
                }
            },
            credits: {
                enabled: false
            },
            series: data
        });
    }

    getStateWisePOBStatusMap() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        var Data = { "type": "StateWisePOB", "EmpId": token.clientId };
        this.http.post('/api/Dashboards/get_POBDashboardDetails', Data)
            .subscribe(res => {
                var POBData: any = [];
                POBData = res ? res : [];
                var Parent = this;
                POBData.forEach(function (e, i) {
                    const latLng = { lat: e.lat, lng: e.lng };
                    let marker = new google.maps.Marker({
                        position: latLng,
                        map: Parent.map,
                    });
                    Parent.addMarker(latLng, Parent.map, "POB: " + e.POB_Value);
                });
            });
    }

    map;
    moveMarker(map, marker, lat, lon) {
        marker.setPosition(new google.maps.LatLng(lat, lon));
        map.panTo(new google.maps.LatLng(lat, lon));
    }

    addMarker(location: google.maps.LatLngLiteral, map: google.maps.Map, title) {
        new google.maps.Marker({
            position: location,
            map: map,
            title: title
        });
    }

    LoadStateWisePOBStatusMap() {
        this.map = new google.maps.Map(document.getElementById("map"), {
            center: new google.maps.LatLng(22.674847, 78.637970),
            zoom: 4.2,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
    }

}
